// extracted by mini-css-extract-plugin
export default {"semeia-chat":"_semeia-chat_qk+jR-"};